import AppLink from "@/integrations/next/components/AppLink"
import { ArrowRight } from "@/ui/icons"
import { CtaColor, CtaVariant } from "@/ui/types/cta"
import { classNames } from "@punks/ui-core"
import Spinner from "../Spinner"
import { ReactNode } from "react"
import { LinkData } from "@/ui/types/link"

export type CtaSize = "sm" | "md" | "lg"

export interface CtaLink2Props {
  className?: string
  label?: ReactNode
  onClick?: () => void
  link?: LinkData
  variant?: CtaVariant
  color?: CtaColor
  noGutter?: boolean
  arrow?: boolean
  loading?: boolean
  size?: CtaSize
  center?: boolean
}

const CtaLink2 = ({
  label,
  className,
  link,
  color,
  onClick,
  variant = "link",
  size = "md",
  noGutter,
  arrow,
  loading,
  center,
}: CtaLink2Props) => {
  const handleClick = () => {
    if (link?.type === "anchor" && link.anchor) {
      const anchorElement = document.getElementById(link.anchor)
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth" })
      }
    }
    onClick?.()
  }

  return (
    <AppLink href={link?.url} target={link?.linkTarget}>
      <div
        className={classNames(
          "group inline-flex flex-row gap-x-2 cursor-pointer leading-[30px] ease-in duration-200 rounded-cta",
          {
            "justify-center": center,
            "px-6": !noGutter && (size === "sm" || size === "md"),
            "py-[13px]": size === "md",
            "py-[6px]": size === "sm",
            // link
            "bold border border-transparent opacity-1 hover:opacity-[80%]":
              variant === "link",
            "text-primary": color === "primary",
            // outlined
            "font-bold border-[2px] opacity-1 hover:opacity-[95%]":
              variant === "outlined",
            "border-black text-black":
              variant === "outlined" && color === "text",
            "text-white border-white hover:bg-white hover:text-black":
              variant === "outlined" && color === "textNegative",
            "text-white border-white hover:bg-white hover:text-primary":
              variant === "outlined" && color === "primaryNegative",
            // filled
            "border-[2px]": variant === "filled",
            "border-white text-black bg-white":
              variant === "filled" && color === "textNegative",
            "border-primary text-white bg-primary hover:bg-transparent hover:text-primary":
              variant === "filled" && color === "primary",
          },
          className
        )}
        onClick={handleClick}
      >
        {loading === true ? <Spinner /> : undefined}
        {label}
        {arrow && (
          <ArrowRight
            className="ease-in duration-200 transform rotate-0 group-hover:rotate-[-45deg]"
            height={30}
            width={30}
          />
        )}
      </div>
    </AppLink>
  )
}

export default CtaLink2
